import { createSlice } from "@reduxjs/toolkit";

const providerRegistrySlice = createSlice({
    name: "providers",
    initialState: {},
    reducers: {
        registerProvider: (state, action) => {
            const provider = action.payload;
            if (provider?.id && !state[provider.id]) {
                state[provider.id] = provider; // Only add if missing
            }
        },

        bulkRegisterProviders: (state, action) => {
            action.payload.forEach((provider) => {
                if (provider?.id && !state[provider.id]) {
                    state[provider.id] = provider; // Only add if missing
                }
            });
        }
    }
});

export const { registerProvider, bulkRegisterProviders } = providerRegistrySlice.actions;
export default providerRegistrySlice.reducer;
